import React, { useEffect, useState, useRef } from 'react';
import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import { DatePicker, Tooltip, Space, Tag, Select } from 'antd';
import PropagateLoader from "react-spinners/PropagateLoader";
import { getUTCToLocalDateTimeFormat, toDayDate, queryDate } from './../../Utils/function';
import { getRequest, postRequest } from './../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { GET_FUND_TRANSFER_USER_LIST } from './../../Utils/appConstants';
import { INRFormat } from './../../Utils/Common';

function MoveToBankReport(props) {
    const history = useHistory();
    const csvLink = useRef();
    const limit = 10;
    const dateFormat = 'DD-MM-YYYY';
    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(toDayDate());
    const [startDate, setStartDate] = useState(toDayDate());
    const [getData, setData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const [isLimit, setLimit] = useState(limit);
    const [searchAccountNumber, setSearchAccountNumber] = useState(null);
    const [searchTransId, setSearchTransId] = useState(null);
    const [searchCustomerId, setSearchCustomerId] = useState(null);
    const [searchStatus, setSearchStatus] = useState(null);
    const [csvData, setCsvData] = useState([]);
    const [invoiceData, setInvoiceData] = useState(null);


    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        if (data) {
            setLimit(data);
            params.limit = data;
        }
        if (startDate && endDate) {
            params.startDate = startDate ? queryDate(startDate) : "";
            params.endDate = endDate ? queryDate(endDate) : "";
        }
        params.searchAccountNumber = searchAccountNumber ? searchAccountNumber : '';
        params.searchCustomerId = searchCustomerId ? searchCustomerId : '';
        params.searchTransId = searchTransId ? searchTransId : '';
        params.searchStatus = searchStatus ? searchStatus : '';
        params.txnType = "move_to_bank";

        const queryString = objectToQueryString(params);
        setLoading(true);
        getRequest(`${GET_FUND_TRANSFER_USER_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs);
                setPage(response.data.page);
            } else {
                setData([]);
                setTotalRecord(0);
                setPage(1);
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error);
            setLoading(false);
        });
    };

    // ---- CSV Export ----
    const getCSVDataList = () => {
        let params = {};
        params.exportsCsv = true;
        if (startDate && endDate) {
            params.startDate = startDate ? queryDate(startDate) : "";
            params.endDate = endDate ? queryDate(endDate) : "";
        }
        params.searchAccountNumber = searchAccountNumber ? searchAccountNumber : '';
        params.searchCustomerId = searchCustomerId ? searchCustomerId : '';
        params.searchTransId = searchTransId ? searchTransId : '';
        params.searchStatus = searchStatus ? searchStatus : '';
        params.txnType = "move_to_bank";

        const queryString = objectToQueryString(params);
        getRequest(`${GET_FUND_TRANSFER_USER_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                const records = response.data;
                const csvRows = records.map(row => ({
                    'Date Time': getUTCToLocalDateTimeFormat(row.createdAt),
                    'Transaction ID': row.transactionId,
                    'Amount': INRFormat(row.amount),
                    'Final Status': row.finalStatus,
                    'Level 1 Status': row.level1Status,
                    'Level 2 Status': row.level2Status,
                    'Mode': 'NEFT',
                    'Customer': row.customerName || row.partnerName,
                    'Beneficiary': row.baneName,
                    'Account Number': row.accountNumber,
                    'IFSC': row.ifsccode,
                    'Checker': row.checker?.username || '',
                    'Maker': row.maker?.username || '',
                }));
                setCsvData(csvRows);
                setTimeout(() => {
                    csvLink.current.link.click();
                }, 500);
            } else {
                setCsvData([]);
                toast.error('No data to export');
            }
        }).catch(function (error) {
            console.log(error);
        });
    };

    const handlePageChange = (page, size) => { setPage(page); };
    const handleSearch = () => { getDataReports(); };
    const handleClear = () => {
        setStartDate('');
        setEndDate('');
        setSearchAccountNumber('');
        setSearchTransId('');
        setSearchCustomerId('');
        setSearchStatus('');
        handleSearch();
    };

    useEffect(() => {
        getDataReports();
    }, [page]);

    // Status mapping
    const getFinalStatus = (row) => {
        const statusMap = {
            'submitted': 'Submitted',
            'in_process': 'In Process',
            'sent_to_bank': 'Sent to Bank',
            'pending_at_bank': 'Pending at Bank',
            'success': 'Success',
            'failed': 'Failed',
            'refunded': 'Refunded'
        };
        return statusMap[row.finalStatus] || row.finalStatus || 'Unknown';
    };

    const columns = [
        {
            name: 'Date Time',
            cell: row => getUTCToLocalDateTimeFormat(row.createdAt),
            width: "200px",
        },
        {
            name: 'Trans ID',
            selector: row => <Tooltip placement="bottom" title={row.transactionId}>{row.transactionId}</Tooltip>,
            width: "180px",
        },
        {
            name: 'Amount',
            selector: row => INRFormat(row.amount),
            width: "100px",
        },
        {
            name: 'Final Status',
            selector: row => getFinalStatus(row),
        },
        // {
        //     name: 'Txn Type',
        //     selector: row => row.txnType || '-',
        //     width: "150px"
        // },
        {
            name: 'Mode',
            selector: () => 'NEFT',
                        width: "80px",

        },
        {
            name: 'Mobile',
            selector: row => row.customerMobile || '-',
        },
        {
            name: 'Beneficiary',
            selector: row => row.baneName || '-',
        },
        {
            name: 'IFSC',
            selector: row => row.ifsccode || '-',
            width: "130px",

        },
        {
            name: 'Account',
            selector: row => row.accountNumber || '-',
            width: "180px",
        },
        {
            name: 'Bank RRN',
            selector: row => row.bank_ref_num || '-',
            width: "180px",
        },
        {
            name: 'Action',
            selector: row => <><button type="button" className='btn btn-sm border border-success text-success' onClick={() => handleInvoice(row)} title='Print Invoice'><i class="fa fa-print" aria-hidden="true"></i></button></>,
            width: "250px",
        },

    ];

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>;
    }

    const handleInvoice = (data) => {
        setInvoiceData(data);
        history.push(`/fundtransferinvoice/${data.transactionId}`);
    }
    return (
        <div>
            <div className="content-wrapper pt-2">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>Move To Bank <span className='text-red'>Report</span></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid pt-2 pb-5">
                        <div className="row">
                            <div className='card col-md-12 py-3'>
                                <div className='card-body p-0'>
                                    <div className="row">
                                        <div className='col-md-12 date-search mb-0'>
                                            <div className='row'>
                                                <div className='col-md-3 col-lg-3 d-flex'>
                                                    <div className="form-group mr-3">
                                                        <label className='date-search-label mb-0 text-blue'>From</label>
                                                        <DatePicker className="form-control form-control-border" value={startDate} format={dateFormat} onChange={(date) => setStartDate(date)} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'>To</label>
                                                        <DatePicker className="form-control form-control-border" value={endDate} format={dateFormat} onChange={(date) => setEndDate(date)} />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3 d-flex'>
                                                    <div className="form-group mr-3">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="Trans ID" onChange={(e) => setSearchTransId(e.target.value)} value={searchTransId} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="Customer" onChange={(e) => setSearchCustomerId(e.target.value)} value={searchCustomerId} />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3 d-flex'>
                                                    <div className="form-group mr-3">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="A/C Number" onChange={(e) => setSearchAccountNumber(e.target.value)} value={searchAccountNumber} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'>&nbsp;</label>
                                                        <Select
                                                            className="w-100"
                                                            value={searchStatus}
                                                            onChange={(value) => setSearchStatus(value)}
                                                            options={[
                                                                { value: '', label: 'All' },
                                                                { value: 'submitted', label: 'Submitted' },
                                                                { value: 'in_process', label: 'In Process' },
                                                                { value: 'sent_to_bank', label: 'Sent to Bank' },
                                                                { value: 'pending_at_bank', label: 'Pending at Bank' },
                                                                { value: 'success', label: 'Success' },
                                                                { value: 'failed', label: 'Failed' },
                                                                { value: 'refunded', label: 'Refunded' },
                                                            ]}
                                                            placeholder="-- Status --"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-12 date-search mb-0'>
                                            <div className='row'>
                                                <div className='col-md-8'></div>
                                                <div className='col-md-1'>
                                                    <button type="submit" className="btn btn-primary rounded-pill px-3" onClick={() => handleSearch()}>Search</button>
                                                </div>
                                                <div className='col-md-1'>
                                                    <button type="submit" className="btn btn-default rounded-pill px-4" onClick={() => handleClear()}>Clear</button>
                                                </div>
                                                <div className='col-md-2'>
                                                    <button type="button" className="btn btn-primary mr-2" onClick={() => getCSVDataList()}>
                                                        <i className="fa fa-file-excel"></i> Export CSV
                                                    </button>
                                                    <CSVLink
                                                        data={csvData}
                                                        filename='my_fund_transfers'
                                                        className='hidden'
                                                        ref={csvLink}
                                                        target='_blank'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container-fluid pt-2 pb-5">
                                        <DataTable
                                            title={""}
                                            columns={columns}
                                            data={getData.docs}
                                            highlightOnHover
                                            pagination
                                            paginationServer
                                            paginationTotalRows={getTotalRecord}
                                            onChangeRowsPerPage={getDataReports}
                                            onChangePage={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MoveToBankReport;